<script>

import * as pdfjsLib from "pdfjs-dist";
import worker from "pdfjs-dist/build/pdf.worker?url";
import opportunityApi from "@/api/opportunity";
import IconChatGpt from "@/font-awesome/IconChatGpt.vue";

pdfjsLib.GlobalWorkerOptions.workerSrc = worker;

export default {
  name: "ImageTranslator",
  components: {IconChatGpt},
  data() {
    return {
      files: [],
      loading: false,
      internalText: this.value,
    };
  },
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  watch: {
    value(newVal) {
      this.internalText = newVal;
    }
  },
  methods: {
    triggerInput() {
      this.$refs.fileInput.click();
    },
    async onDrop(e) {
      const file = e.dataTransfer.files[0];

      await this.handle(file);
    },
    async handleFiles(e) {
      await this.handle(e.target.files[0]);
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async handle (file) {
      this.loading = true;

      if (file.type.startsWith("image/")) {
        const image = await this.toBase64(file);
        await this.analyseImage(image);
      } else {
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext("2d");

        let pagesImages = [];

        const buffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({data: buffer}).promise;

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);

          const viewport = page.getViewport({scale: 2});

          const tempCanvas = document.createElement("canvas");
          const tempCtx = tempCanvas.getContext("2d");

          tempCanvas.width = viewport.width;
          tempCanvas.height = viewport.height;

          await page.render({
            canvasContext: tempCtx,
            viewport
          }).promise;

          pagesImages.push(tempCanvas);
        }

        const width = Math.max(...pagesImages.map(c => c.width));
        const height = pagesImages.reduce((sum, c) => sum + c.height, 0);

        canvas.width = width;
        canvas.height = height;

        let offsetY = 0;

        for (const img of pagesImages) {
          ctx.drawImage(img, 0, offsetY);
          offsetY += img.height;
        }

        const image = canvas.toDataURL("image/png");

        await this.analyseImage(image);
      }

      this.loading = false;
    },
    async analyseImage(image) {
      const { data } = await opportunityApi.analyze({ image });

      this.internalText = data.data.replace("\\n", "").replace('\\"', '"');

      this.$emit("input", this.internalText);

      this.$notification.success('The content was successfully transcribed!')
    },
  },
}
</script>

<template>
  <div
    class="upload-box"
    @click="triggerInput"
    @dragover.prevent
    @drop.prevent="onDrop"
  >
    <input
      ref="fileInput"
      type="file"
      class="hidden-input"
      accept="application/pdf,image/png,image/jpg,image/jpeg"
      :disabled="loading"
      @change="handleFiles"
    />
    <canvas ref="canvas" style="display:none;"></canvas>
    <div class="content">
      <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="loading" />
      <i class="mr-4" v-else>
        <IconChatGpt
          class="icon is-small"
          style="height: 1.5rem; width: 1.5rem"
        />
      </i>
      <div class="text">Upload the pricing table</div>
    </div>
  </div>
</template>

<style scoped>
.upload-box {
  border: 2px dashed #00a8cc;
  border-radius: 16px;
  padding: 20px;
  background: #f5f7f9;
  cursor: pointer;
  transition: all 0.2s ease;
}

.upload-box:hover {
  background: #eef6f8;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.icon {
  font-size: 20px;
}

.text {
  font-weight: 600;
  color: #1f2d3d;
}

.hidden-input {
  display: none;
}
</style>
